import script from "./MiniFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./MiniFooter.vue?vue&type=script&setup=true&lang=js"

import "./MiniFooter.vue?vue&type=style&index=0&id=9c880cae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c880cae"]])

export default __exports__